import { Link } from 'react-router'
import type { Route } from './+types/contact-us.thank-you'
import { PartHead } from '#app/components/marketing/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Thank You | Frame & Ledger' },
	{ name: 'description', content: 'Your consultation request was received.' },
]

export default function ThankYou() {
	return (
		<section className="border-t border-[var(--rule-soft)] py-12 first:border-t-0 first:pt-6 lg:py-16">
			<PartHead num="✓" kicker="Received">
				Thank you<span className="text-gold">.</span>
			</PartHead>
			<div className="flex max-w-[60ch] flex-col gap-6">
				<p className="lede text-muted-foreground">
					Your application is in our inbox. One of the partners — Adam or Jon —
					will read it personally and reply within three business days.
				</p>
				<p className="text-muted-foreground">
					If we’re a fit, the reply will propose a 30-minute discovery call. If
					we’re not, we’ll say so directly and point you toward firms that are.
					Either way: a real human, within 3 business days.
				</p>
				<div className="mt-6 flex flex-wrap items-center gap-6 border-t border-[var(--rule-soft)] pt-6">
					<Link
						to="/"
						className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.14em] uppercase transition-colors"
					>
						<span aria-hidden="true">←</span>
						<span>Back to Frame & Ledger</span>
					</Link>
				</div>
			</div>
		</section>
	)
}
